import { Injectable } from '@angular/core';
import { firstValueFrom, map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CaqRequestService } from '../caq-request/caq-request.service';
import { Escola } from '../../interfaces/location.interface';
import { ProjecaoOfertaMatriculas } from '../../dtos';

interface ListMatriculasPorEscola {
  diagnosticos: ProjecaoOfertaMatriculas[];
}

@Injectable({
  providedIn: 'root'
})
export class EscolasService {
  private baseApiUrl = `${environment.apiUrl}/diagnostico-de-matricula-de-escola`;

  constructor(private caqRequestService: CaqRequestService) {}

  // Busca todas as escolas de um município para o dropdown da seleção de local
  buscarEscolasPorMunicipio(codMun: number | string, tipoSimulacao?: number): Promise<Escola[]> {
    const tipo = tipoSimulacao === 2 ? 'rede-municipal' : 'plano-municipal';
    const endpoint = `${this.baseApiUrl}/${tipo}/${codMun}`;

    return firstValueFrom(
      this.caqRequestService.get<ListMatriculasPorEscola>(endpoint).pipe(
        map((response) => {
          const diagnosticos = response.diagnosticos || [];
          return diagnosticos.map(d => ({
            codMec: d.codMec,
            nomeInstituicao: d.nomeInstituicao,
            localizacao: d.localizacao,
            codMun: d.codMun,
            codUf: d.codUf
          }));
        })
      )
    );
  }

  // Busca todas as escolas de um estado
  buscarEscolasPorEstado(codUf: number | string): Promise<Escola[]> {
    // TODO
    return Promise.resolve([]);
  }

  // Busca todas as escolas do país
  buscarTodasEscolas(): Promise<Escola[]> {
    // TODO
    return Promise.resolve([]);
  }
}
